import { useFlagOnaAIEnabled } from "@/hooks/use-flag";
import { PendingExperimentActivation } from "@/routes/experiments/ExperimentsActivationPage";
import { useCanUseExperiments } from "@/hooks/use-experiment";
import { parseAsBoolean, useQueryState } from "nuqs";
import type { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

const useDefaultRedirect = () => {
    const { value: onaEnabled, loading: isLoadingOnaAIEnabled } = useFlagOnaAIEnabled();

    if (isLoadingOnaAIEnabled) {
        return null;
    }

    if (onaEnabled) {
        return "/ai";
    }

    return "/projects";
};

export const SlashRedirect: FC = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { state } = useLocation();
    const to = useDefaultRedirect();
    const [autoStart] = useQueryState("autostart", parseAsBoolean.withDefault(false));

    // Process any pending experiment activation from before login/onboarding
    const { canUse, isEnterprise } = useCanUseExperiments();

    if (!to) {
        return null;
    }

    return (
        <>
            <PendingExperimentActivation canUse={canUse} isEnterprise={isEnterprise} />
            <Navigate
                to={{ pathname: to, hash: document.location.hash, search: document.location.search }}
                replace
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                state={{ ...state, showCreateModal: !!document.location.hash, autoStart }}
            />
        </>
    );
};
